
import React, { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

const EducationPage = lazy(() => import("@/pages/calculators/EducationPage"));
const GraphingCalculatorPage = lazy(() => import("@/pages/calculators/education/GraphingCalculatorPage"));
const GeometryCalculatorPage = lazy(() => import("@/pages/calculators/education/GeometryCalculatorPage"));
const GPACalculatorPage = lazy(() => import("@/pages/calculators/education/GPACalculatorPage"));
const GradeCalculatorPage = lazy(() => import("@/pages/calculators/education/GradeCalculatorPage"));
const StudyTimeOptimizerPage = lazy(() => import("@/pages/calculators/education/StudyTimeOptimizerPage"));
const AcademicProgressTrackerPage = lazy(() => import("@/pages/calculators/education/AcademicProgressTrackerPage"));
const TriangleCalculatorPage = lazy(() => import("@/pages/calculators/education/TriangleCalculatorPage"));
const RandomNumberGeneratorPage = lazy(() => import("@/pages/calculators/education/RandomNumberGeneratorPage"));
const ProbabilityCalculatorPage = lazy(() => import("@/pages/calculators/education/ProbabilityCalculatorPage"));
const StatisticalSignificanceCalculatorPage = lazy(() => import("@/pages/calculators/education/StatisticalSignificanceCalculatorPage"));
const ScientificCalculatorPage = lazy(() => import("@/pages/calculators/education/ScientificCalculatorPage"));
const MatrixCalculatorPage = lazy(() => import("@/pages/calculators/education/MatrixCalculatorPage"));

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="flex items-center justify-center min-h-[50vh]"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>}>
    {children}
  </Suspense>
);

const EducationRoutes = [
  <Route path="/calculators/education" element={<Lazy><EducationPage /></Lazy>} key="education" />,
  <Route path="/calculators/education/graphing" element={<Lazy><GraphingCalculatorPage /></Lazy>} key="graphing" />,
  <Route path="/calculators/education/scientific" element={<Lazy><ScientificCalculatorPage /></Lazy>} key="scientific" />,
  <Route path="/calculators/education/matrix" element={<Lazy><MatrixCalculatorPage /></Lazy>} key="matrix" />,
  <Route path="/calculators/education/gpa" element={<Lazy><GPACalculatorPage /></Lazy>} key="gpa" />,
  <Route path="/calculators/education/grade" element={<Lazy><GradeCalculatorPage /></Lazy>} key="grade" />,
  <Route path="/calculators/education/study-time" element={<Lazy><StudyTimeOptimizerPage /></Lazy>} key="study-time" />,
  <Route path="/calculators/education/academic-progress" element={<Lazy><AcademicProgressTrackerPage /></Lazy>} key="academic-progress" />,
  <Route path="/calculators/education/triangle" element={<Lazy><TriangleCalculatorPage /></Lazy>} key="triangle" />,
  <Route path="/calculators/education/random-number" element={<Lazy><RandomNumberGeneratorPage /></Lazy>} key="random-number" />,
  <Route path="/calculators/education/probability" element={<Lazy><ProbabilityCalculatorPage /></Lazy>} key="probability" />,
  <Route path="/calculators/education/statistical-significance" element={<Lazy><StatisticalSignificanceCalculatorPage /></Lazy>} key="statistical-significance" />,
  <Route path="/calculators/education/geometry" element={<Lazy><GeometryCalculatorPage /></Lazy>} key="geometry" />,
];

export default EducationRoutes;
